<template>
  <div class="not-allowed-view">
    <h2 class="code-error">{{ errorCode }}</h2>
    <div class="description">{{ description }}</div>
  </div>
</template>

<script>
export default {
  props: {
    errorCode: {
      type: Number,
      default: 0
    },
    description: {
      type: String,
      default: 'Not allowed view'
    }
  }
}
</script>

<style lang="scss" scoped>
.not-allowed-view {
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  z-index: 1000;
  .code-error {
    font-size: 5rem;
  }
}
</style>
